import { forwardRef, type PropsWithChildren, type ReactNode } from "react";

import clsx from "clsx";

import { NavLinkContent } from "./nav-link-content";
import { Tooltip } from "./tooltip";

interface Props {
  isExpanded: boolean;
  icon: ReactNode;
  disabled?: boolean;
  showTooltip?: boolean;
  onClick?: () => void;
}

export const NavButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<Props>
>(({ isExpanded, icon, disabled, showTooltip, children, onClick }, ref) => {
  return (
    <Tooltip
      showTooltip={showTooltip}
      hideShortcut
      content={isExpanded ? null : children}
    >
      <button
        ref={ref}
        disabled={disabled}
        className={clsx("block w-full cursor-pointer", {
          "m-1.5": !isExpanded,
          "pointer-events-none opacity-50": disabled,
        })}
        onClick={onClick}
      >
        <NavLinkContent isActive={false} icon={icon} isExpanded={isExpanded}>
          {children}
        </NavLinkContent>
      </button>
    </Tooltip>
  );
});
